import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset scroll is on its way.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Send a reset scroll"
      subtitle="We will courier a link to your inbox — if the email is on our ledger."
      footer={<Link to="/login" className="text-amber-500 hover:text-amber-400 underline">Back to sign in</Link>}
    >
      {sent ? (
        <div className="text-stone-300 font-body" data-testid="forgot-success">
          If <span className="text-amber-400">{email}</span> has an account, a
          reset link was sent. Check your inbox (and spam).
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4 font-body" data-testid="forgot-form">
          <label className="block">
            <span className="text-stone-400 text-sm mb-1 block">Email</span>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
              data-testid="forgot-email"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            className="btn-gold w-full py-2.5"
            data-testid="forgot-submit"
          >
            {submitting ? "Dispatching…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
